import { render, staticRenderFns } from "./RefundDlg.vue?vue&type=template&id=62cbff2e&scoped=true&"
import script from "./RefundDlg.vue?vue&type=script&lang=js&"
export * from "./RefundDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cbff2e",
  null
  
)

export default component.exports